// Default config for local development (quasar dev).
// In production, the unified build fetches config from the API at runtime
// based on the URL slug (e.g., /quizapps/dentistry/ → GET /api/quiz-app/config/dentistry).
//
// Change qbank_source here to test different products locally.

module.exports = {
  qBankName: 'Emtyaz',
  qbank_source: 1,
  publicPath: '/quizapps/',
  content_direction: 'ltr',
  qbank_app_slug: 'emtyaz_residency',
};
